<template>
  <input
    :id="props.field.name"
    v-model="selectedValue"
    v-focus
    class="flex w-full shrink grow basis-0 flex-col items-start justify-start gap-2.5 self-stretch rounded-lg
      border border-gray-200 bg-white px-2 py-[22px] shadow sm:w-[400px] sm:px-5"
    :class="`focus:outline-none focus:border-${themeColor}-500 focus:border-2`"
    :placeholder="getPlaceholder(props.field.type)"
    :type="getInputType(props.field.type)"
    :name="props.field.name"
    @input="handleInput"
  />
</template>

<script setup lang="ts">
  import { useFormField } from '@/composables/useFormField'
  import { computed, onMounted } from 'vue'
  import { useThemeColor } from '@/composables/useThemeColor'

  const emit = defineEmits(['update:modelValue'])

  const props = defineProps({
    field: {
      type: Object,
      default: null
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  })

  const { selectedValue, vFocus } = useFormField(props)
  const themeColor = computed(() => useThemeColor().value)

  function getInputType(fieldType: string): string {
    switch (fieldType) {
      case 'emailinput':
        return 'email'
      case 'phoneinput':
        return 'tel'
      case 'numberinput':
        return 'number'
      case 'decimalnumberinput':
        return 'number'
      case 'urlinput':
        return 'url'
      case 'timefield':
        return 'time'
      default:
        return 'text'
    }
  }

  function getPlaceholder(fieldType: string): string {
    switch (fieldType) {
      case 'emailinput':
        return 'Geben Sie hier Ihre E-Mail-Adresse ein...'
      case 'phoneinput':
        return 'Geben Sie hier Ihre Telefonnummer ein...'
      case 'numberinput':
        return 'Geben Sie hier eine Zahl ein...'
      case 'urlinput':
        return 'Geben Sie hier eine URL ein...'
      default:
        return 'Geben Sie hier Ihre Antwort ein...'
    }
  }

  function handleInput(event: Event) {
    const target = event.target as HTMLInputElement
    let value: string | number = target.value

    if (props.field.type === 'numberinput') {
      value = target.valueAsNumber
    }

    emit('update:modelValue', value)
  }
</script>
